import { AutogenLayoutRenditionDocumentProfiles } from "./autogen/AutogenLayoutRenditionDocumentProfiles";
import {  DropdownSelectionEvent,  DataDisplayEvent,  DataSourceExecutionEvent,  KeyEvent } from "@mcleod/components";
import { DropdownItem } from "@mcleod/components";

export class RenditionDocumentProfiles extends AutogenLayoutRenditionDocumentProfiles {
    private timer: any;
    private scnt = 0;

    override onLoad() {
        //console.log(this);
        clearInterval(this.timer);
        this.timer = setInterval(() => this.tbDocpCatidSetItems(), 250);
    }

/** This is an event handler for the onDropdownSelection event of tbDocpAppid. */
    async tbDocpAppidAfterDropdownSelection(event: DropdownSelectionEvent) {
        const appid = event.selection.value;
        await this.sourceImapCats.search( { "icat_appid": appid });
        const items: DropdownItem[] = [];
        const rows: any = this.sourceImapCats.data;
        for( const row of rows )
        {
            const app2: any = row._data.icat_appid;
            if( appid == app2 )
            {
                let catdesc: string = row._data.icat_catdesc;
                catdesc = catdesc.replace("&", "");
                //items.push({ caption: catdesc, value: row._data.icat_catid.toString() });
                items.push(new DropdownItem(row._data.icat_catid.toString(), catdesc));
            }
        }
        this.tbDocpCatid.text = "";
        this.tbDocpCatid.items = items;
    }

/** This is an event handler for the afterExecution event of sourceImgApps. */
    sourceImgAppsAfterExecution(event: DataSourceExecutionEvent) {
        const items: DropdownItem[] = [];
        const rows: any = this.sourceImgApps.data;
        for( const row of rows )
        {
            let appname: string = row._data.imap_appname;
            appname = appname.replace("&", "");
            //items.push({ caption: appname, value: row._data.imap_appid });
            items.push(new DropdownItem(row._data.imap_appid, appname));
        }
        this.tbDocpAppid.items = items;
        this.scnt++;
    }

/** This is an event handler for the afterExecution event of sourceImapCats. */
    sourceImapCatsAfterExecution(event: DataSourceExecutionEvent) {
        this.scnt++;
    }

  async tbDocpCatidSetItems() {
    if( this.scnt < 2 )
        return; //insure data sources loaded
    clearInterval(this.timer);
    this.timer = null;
    if( this.sourceRenditionDocumentProfiles.mode == "add" )
    {   //in add mode
        this.tbDocpSeq.text = "";
        this.tbDocpAppid.text = "";
        this.tbDocpCatid.text = "";
        this.tbDocpId.text = "";
        this.ntbDocpId.visible = true;
        this.tbDocpId.caption = "New Document Profile";
    }
    else
    {   //in update mode
        let appid=null;
        for( let i=0; i < this.tbDocpAppid.items.length; i++ )
        {
            if( this.tbDocpAppid.text == this.tbDocpAppid.items[i]._displayValue )
            {
                appid = this.tbDocpAppid.items[i].value;
                break;
            }
        }
        const items: DropdownItem[] = [];
        const rows: any = this.sourceImapCats.data;
        let idx = 0;
        let iidx = 0;
        for( const row of rows )
        {
            const app2: any = row._data.icat_appid;
            if( appid == app2 )
            {
                if( parseInt(this.tbDocpCatid.text) == row._data.icat_catid )
                    iidx = idx;
                idx++;
                let catdesc: string = row._data.icat_catdesc;
                catdesc = catdesc.replace("&", "");
                //items.push({ caption: catdesc, value: row._data.icat_catid.toString() });
                items.push(new DropdownItem(row._data.icat_catid.toString(), catdesc));
            }
        }
        this.tbDocpCatid.items = items;
        //set selected item
        this.tbDocpCatid.selectedItem = this.tbDocpCatid.items[iidx];
        this.tbDocpId.enabled = false;
        this.tbDocpAppid.enabled = false;
    }
  }

/** This is an event handler for the afterExecution event of sourceRenditionDocumentProfiles. */
  sourceRenditionDocumentProfilesAfterExecution(event: DataSourceExecutionEvent) {
    if( this.tbDocpId.items )
        return;
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    let docpid = null;
    for (const row of rows) {
        //console.log("Row: ", row );
        if( docpid != row._data.docp_id )
        {
            docpid = row._data.docp_id;
            //items.push({ caption: row._data.docp_id, value: row._data.docp_id });
            items.push(new DropdownItem(row._data.docp_id, row._data.docp_id));
        }
    }
    this.tbDocpId.items = items;
}

/** This is an event handler for the onDropdownSelection event of ntbDocpId. */
  ntbDocpIdAfterDropdownSelection(event: DropdownSelectionEvent) {
    this.tbDocpId.text = this.ntbDocpId.text;
    this.GetNewSeq();
  }

/** This is an event handler for the afterExecution event of sourceRenditionDocProf. */
  sourceRenditionDocProfAfterExecution(event: DataSourceExecutionEvent)
  { //used when in add mode
    if( this.ntbDocpId.items )
        return;
    const rows: any[] = event.dataSource.data;
    const items: DropdownItem[] = [];
    let docpid = null;
    for (const row of rows) {
        //console.log("Row: ", row );
        if( docpid != row._data.docp_id )
        {
            docpid = row._data.docp_id;
            //items.push({ caption: row._data.docp_id, value: row._data.docp_id });
            items.push(new DropdownItem(row._data.docp_id, row._data.docp_id));
        }
    }
    this.ntbDocpId.items = items;
  }

  async GetNewSeq()
  {
    let seq=0, pseq=0;
    //const row: any = this.sourceRenditionDocProf.activeRow;
    if( this.sourceRenditionDocumentProfiles.mode == "add" )
    {   //Adding a new record
        await this.sourceRenditionDocProf.search( { docp_id: this.tbDocpId.text, docp_seq: ">0" } );
        for( let i=0; i < this.sourceRenditionDocProf.rowCount; i++ )
        {
            this.sourceRenditionDocProf.rowIndex = i;
            seq = this.sourceRenditionDocProf.activeRow.data.docp_seq;
            if( seq > pseq )
                pseq = seq;
        }
    }
    if( pseq > 0 )
    {
        pseq += 1;
        this.tbDocpSeq.text = pseq.toString();
        //this.tbDocpSeq.enabled = false;
    }
  }

}
